console.log('js/lp_flexible_duration.js -> v0.1.0');
$(function() {

	$('.price').each(function() {
		$(this).attr('data-original-html', $(this).html());
	});

	function addOptions(){
		var duration = 3;
		var duration_original = parseInt($("#duration_in_days_original").val());
		while(duration <= duration_original * 2) {
			var text = $('#lp_variable_duration_select').attr('data-transtag').replace('DAYS',duration).replace('NIGHTS',duration-1);
			var selected = '';
			if(duration == duration_original){selected = 'selected="selected"';};
			$("#lp_variable_duration_select").append('<option '+selected+' value="'+duration+'">'+text+'</option>');
			duration++;
		};
	};

	$("#lp_variable_duration_select").change(function(){
		$("#duration_in_days").val(parseInt($("#lp_variable_duration_select").val())).change();
		gae('listingPage','duration_select');
	});

	// I added some logic here to prevent errors when no "#lp_variable_duration_select" element is found.
	// ~ David Y. Stephenson, 2017-09-04
	$(document).on('change', '#duration_in_days', () => {
		const duration = parseInt($('#duration_in_days').val())
		const selection = $('#lp_variable_duration_select')
		if (selection.length > 0) {
			if (selection.attr('data-transtag')) {
				const transtag = selection.attr('data-transtag')
				const text = transtag.replace('DAYS', duration).replace('NIGHTS', duration - 1)

				$('.js-insert-duration').html(text)
				$('#lp_variable_duration_select').val(duration)
			} else {
				console.warn('data-transtag attribute could not be found on #lp_variable_duration_select element.')
				gae('jsWarning', 'lp_variable_duration_select.data-transtag-noAttribute')
			}
		}
	})

	$("#listing_query_arrival_date").change(function(){
		$("#duration_in_days").change();
	});

	$("#duration_in_days_plus").click(function(){
		var duration = parseInt($("#duration_in_days").val());
		var duration_original = parseInt($("#duration_in_days_original").val());
		$("#duration_in_days").val(parseInt($("#lp_variable_duration_select").val())).change();
		if (duration < duration_original * 2) {
			$("#duration_in_days").val(duration+1).change();
		};
		gae('listingPage','duration_plus');
	});
	$("#duration_in_days_minus").click(function(){
		var duration = parseInt($("#duration_in_days").val());
		var duration_original = parseInt($("#duration_in_days_original").val());
		$("#duration_in_days").val(parseInt($("#lp_variable_duration_select").val())).change();
		if (duration > 3 || duration > duration_original) {
			$("#duration_in_days").val(duration-1).change();
		};
		gae('listingPage','duration_minus');
	});

	if ($('#price_needs_approval').val() == "1") {
		$('.price_, .price').css('color','red');
	}

	$(document).on('change', '#duration_in_days', function(){
		if ($('#duration_in_days').length && $('#duration_in_days_original').length) {
			var duration = parseInt($("#duration_in_days").val() - 1),
				duration_original = parseInt($("#duration_in_days_original").val() - 1);

			if (duration != duration_original) {
				$("#reservation-query-submit, .js-reserve-link, .js-book-link").addClass('hide');
				$('.js-show-on-custom-package').removeClass('hide');
				$('.input-wpr').find('.package-selection-item').each( function() {
					$(this).attr("data-is-flexible-duration", 1)
				})
			} else {
				$("#reservation-query-submit, .js-reserve-link, .js-book-link").removeClass('hide');
				$('.js-show-on-custom-package').addClass('hide');
				$('.input-wpr').find('.package-selection-item').each( function() {
					$(this).attr("data-is-flexible-duration", 0)
				})
			}


		if (duration === duration_original) {
			$('.price').each(function() {
				var originalHtml = $(this).attr('data-original-html');
				if (originalHtml !== undefined) {
					$(this).html(originalHtml);
				}
			});
			return;
		}

		var min_price = 0;
		$('.price').each(function() {
			if ($(this).attr('data-price')) {
				var numeric_price = parseInt($(this).data("price"));
				if (numeric_price < min_price || min_price == 0)
					min_price = numeric_price;
			}
		});

		$('.price').each(function() {
				if ($(this).html().length) {
					var $price = $(this);
					var price = $price.html();
					var priceId = $price.attr('id');
					
					var discountId = null;
					var discountPercentage = 0;
					var discountFormat = null;
					var discountAmount = null;
					var discountAmountCurrency = null;
					
					if (priceId && priceId.indexOf('listing-query-package-price-') === 0) {
						var packageId = priceId.replace('listing-query-package-price-', '');
						var $packageInput = $('input[data-id="' + packageId + '"].package-selection-item');
						if ($packageInput.length) {
				discountId = $packageInput.attr('data-discount-id');
				if (discountId) {
					discountFormat = $packageInput.attr('data-discount-format');
					if (discountFormat === 'percentage') {
						discountPercentage = $packageInput.attr('data-discount-percentage') ? parseInt($packageInput.attr('data-discount-percentage')) : 0;
					} else if (discountFormat === 'amount') {
						discountAmount = $packageInput.attr('data-discount-amount') ? parseInt($packageInput.attr('data-discount-amount')) : 0;
						discountAmountCurrency = $packageInput.attr('data-discount-amount-currency');
					}
					var flexDiscountExpDays = $packageInput.attr('data-discount-expiration-days');
					if (flexDiscountExpDays) {
						var flexArrivalDateVal = $('#listing_query_arrival_date').val() || $('#arrival_date_select').val();
						if (flexArrivalDateVal && typeof isDiscountActivated === 'function') {
							var flexDiscountType = $packageInput.attr('data-discount-type');
							if (!isDiscountActivated(parseInt(flexDiscountExpDays), new Date(flexArrivalDateVal), flexDiscountType)) {
								discountId = null;
							}
						}
					}
				}
						}
					}
					
					// Create a temporary div element to parse the HTML string
					var tempDiv = document.createElement('div');
					tempDiv.innerHTML = price;
					
					if ($(this).attr('data-price'))
						numeric_price = parseInt($(this).attr("data-price")); // for packages
					else
						numeric_price = min_price; // for the "price from .."

					var price_is_indicative_note = ((duration == duration_original) || $(this).attr('data-price')) ? "" : "<small> (" + $("#price_is_indicative_hidden").val() + ")</small>";

					// SEPARATE LOGIC: Check and calculate discount based on format
					var hasDiscount = false;
					var flexibleOldPrice = Math.round(numeric_price * duration / duration_original);
					var flexibleDiscountPrice = null;
					
					if (discountId) {
						if (discountFormat === 'percentage' && discountPercentage > 0) {
							hasDiscount = true;
							flexibleDiscountPrice = Math.round(flexibleOldPrice * (100 - discountPercentage) / 100);
						}
						else if (discountFormat === 'amount' && discountAmount && discountAmount !== '' && discountAmount !== '0' && discountAmount !== 'null') {
							var amountValue = parseInt(discountAmount);
							if (!isNaN(amountValue) && amountValue > 0) {
								hasDiscount = true;
								
								if (discountAmountCurrency && discountAmountCurrency.toUpperCase() !== selectedCurrency.toUpperCase() && typeof currency !== 'undefined' && currency && currency.convert) {
									var amountInCents = amountValue * 100;
									var $priceElement = $(this);
									
									currency.convert(amountInCents, discountAmountCurrency.toUpperCase(), selectedCurrency.toUpperCase())
										.then(function(response) {
								var convertedAmountInCents = response.to.amount;
										var calculatedFlexibleDiscountPrice = Math.round(flexibleOldPrice - (convertedAmountInCents / 100));
											
											if(calculatedFlexibleDiscountPrice !== null && calculatedFlexibleDiscountPrice !== undefined && !isNaN(calculatedFlexibleDiscountPrice) && calculatedFlexibleDiscountPrice > 0 && calculatedFlexibleDiscountPrice < flexibleOldPrice) {
												var oldPriceEl = tempDiv.querySelector('.listing-old-price');
												var discountPriceEl = tempDiv.querySelector('.listing-discount-price');
												
												if (oldPriceEl && discountPriceEl) {
													oldPriceEl.innerHTML = formatCurrency(flexibleOldPrice);
													discountPriceEl.innerHTML = formatCurrency(calculatedFlexibleDiscountPrice);
													$priceElement.html(oldPriceEl.outerHTML + ' ' + discountPriceEl.outerHTML + price_is_indicative_note);
												} else {
													$priceElement.html(`<div class="listing-old-price">${formatCurrency(flexibleOldPrice)}</div> <div class="listing-discount-price">${formatCurrency(calculatedFlexibleDiscountPrice)}</div>${price_is_indicative_note}`);
												}
											} else {
												var patt = /\d/igm;
												var match = patt.exec(price);
												if (match) {
													var currency = price.substring(0,match.index);
													var finalPrice = Math.round(numeric_price * duration / duration_original);
													$priceElement.html(currency + finalPrice + price_is_indicative_note);
												}
											}
										})
										.catch(function(error) {
											console.error('Currency conversion error:', error);
								var calculatedFlexibleDiscountPrice = Math.round(flexibleOldPrice - amountValue);
										if(calculatedFlexibleDiscountPrice !== null && calculatedFlexibleDiscountPrice !== undefined && !isNaN(calculatedFlexibleDiscountPrice) && calculatedFlexibleDiscountPrice > 0 && calculatedFlexibleDiscountPrice < flexibleOldPrice) {
											$priceElement.html(`<div class="listing-old-price">${formatCurrency(flexibleOldPrice)}</div> <div class="listing-discount-price">${formatCurrency(calculatedFlexibleDiscountPrice)}</div>${price_is_indicative_note}`);
											} else {
												var patt = /\d/igm;
												var match = patt.exec(price);
												if (match) {
													var currency = price.substring(0,match.index);
													var finalPrice = Math.round(numeric_price * duration / duration_original);
													$priceElement.html(currency + finalPrice + price_is_indicative_note);
												}
											}
										});
									return;
								} else {
									flexibleDiscountPrice = Math.round(flexibleOldPrice - amountValue);
								}
							}
						}
					}
					
					if(hasDiscount && flexibleDiscountPrice !== null && flexibleDiscountPrice !== undefined && !isNaN(flexibleDiscountPrice) && flexibleDiscountPrice > 0 && flexibleDiscountPrice < flexibleOldPrice){
						
						var oldPriceElement = tempDiv.querySelector('.listing-old-price');
						var discountPriceElement = tempDiv.querySelector('.listing-discount-price');
						
						if (oldPriceElement && discountPriceElement) {
							oldPriceElement.innerHTML = formatCurrency(flexibleOldPrice);
							discountPriceElement.innerHTML = formatCurrency(flexibleDiscountPrice);
							$(this).html(oldPriceElement.outerHTML + ' ' + discountPriceElement.outerHTML + price_is_indicative_note);
						} else {
							$(this).html(`<div class="listing-old-price">${formatCurrency(flexibleOldPrice)}</div> <div class="listing-discount-price">${formatCurrency(flexibleDiscountPrice)}</div>${price_is_indicative_note}`);
						}
				}else{
					numeric_price = Math.round(numeric_price * duration / duration_original);
					var existingOldEl = tempDiv.querySelector('.listing-old-price');
					var existingDiscountEl = tempDiv.querySelector('.listing-discount-price');
					if (existingOldEl && existingDiscountEl) {
						var discountRaw = parseInt(existingDiscountEl.textContent.replace(/[^\d]/g, '')) || 0;
						var scaledDiscount = discountRaw > 0 ? Math.round(discountRaw * duration / duration_original) : 0;
						if (scaledDiscount > 0 && scaledDiscount < numeric_price) {
							$(this).html(`<div class="listing-old-price">${formatCurrency(numeric_price)}</div> <div class="listing-discount-price">${formatCurrency(scaledDiscount)}</div>${price_is_indicative_note}`);
						} else {
							$(this).html(formatCurrency(numeric_price) + price_is_indicative_note);
						}
					} else {
						var patt = /\d/igm;
						var match = patt.exec(price);
						if (match) {
							var currency = price.substring(0,match.index);
							$(this).html(currency + numeric_price + price_is_indicative_note);
						}
					}
				}
				}
			});


		}
	});

	addOptions();

	function formatCurrency(x) {
		return selectedCurrencyFormat.replace("{amount}", x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
	}
});
